<div class="filter">
    <div class="dropdown">
        <mat-form-field hideRequiredMarker="false" *ngIf="groups !== undefined && groups.length > 0">
            <mat-label>{{ 'TRIP.GROUPNAME' | translate }}</mat-label>
            <mat-chip-grid #chipList3>
              <mat-chip-row class="trip-list-mat-chip"
                *ngIf="selectedGroup"
                (removed)="unselectGroup()">
                {{ selectedGroup.groupName }}
                <mat-icon matChipRemove >cancel</mat-icon>
              </mat-chip-row>
              <input *ngIf="!selectedGroup"
                type="text"
                placeholder
                required
                matInput
                [formControl]="myControlGroup"
                [matAutocomplete]="auto3"
                [matChipInputFor]="chipList3"
              />
            </mat-chip-grid>
            <mat-autocomplete
              #auto3="matAutocomplete"
              (optionSelected)="selectGroup($event.option.value)"
              [displayWith]="displayGroup"
            >
<mat-option *ngFor="let group of filteredGroups | async" [value]="group">
  <span hierarchicalGroupStyle [groupPath]="group.groupIdentifier">
    {{ group.groupIdentifier | hierarchicalGroup }}
  </span>
</mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ 'VEHICLE.NAME' | translate }}</mat-label>
            <input matInput (keyup.enter)="queryByFilter(true)" (blur)="queryByFilter(true)" [(ngModel)]="globalFilter" [disabled]="!selectedGroup"/>
            <button mat-button *ngIf="globalFilter" matSuffix mat-icon-button aria-label="Clear" (click)="globalFilter=''; queryByFilter(true)">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <div class="filter-break"></div>
          <!-- Second row: Date/time filters -->
          <!-- Start date picker -->
          <mat-form-field>
            <mat-label>{{ 'TRIP.FROM_DATE' | translate }}</mat-label>
            <input
              matInput
              [matDatepicker]="startDatePicker"
              [max]="maxDate"
              autocomplete="off"
              [formControl]="myControlStartDate"
              [errorStateMatcher]="errorStateMatcher"
            />
            <mat-error *ngIf="!startDateValid">{{ 'TRIP.INVALID_DATE' | translate }}</mat-error>
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <button *ngIf="myControlStartDate.value" mat-button matSuffix mat-icon-button aria-label="Clear" (click)="resetStartDate()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>
          
          <!-- Start time picker -->
          <mat-form-field>
            <mat-label>{{ 'TRIP.FROM_TIME' | translate }}</mat-label>
            <input matInput [matTimepicker]="startTimePicker" [formControl]="myControlStartTime">
            <mat-timepicker-toggle matIconSuffix [for]="startTimePicker"/>
            <button *ngIf="myControlStartTime.value" mat-button matSuffix mat-icon-button aria-label="Clear" (click)="resetStartTime()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-timepicker #startTimePicker/>
          </mat-form-field>
      
          <!-- End date picker -->
          <mat-form-field>
            <mat-label>{{ 'TRIP.TO_DATE' | translate }}</mat-label>
            <input
              matInput
              [matDatepicker]="endDatePicker"
              [max]="maxDate"
              autocomplete="off"
              [formControl]="myControlEndDate"
              [errorStateMatcher]="errorStateMatcher"
            />
            <mat-error *ngIf="!endDateValid">{{ 'TRIP.INVALID_DATE' | translate }}</mat-error>
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <button *ngIf="myControlEndDate.value" mat-button matSuffix mat-icon-button aria-label="Clear" (click)="resetEndDate()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </mat-form-field>
          
          <!-- End time picker -->
          <mat-form-field>
            <mat-label>{{ 'TRIP.TO_TIME' | translate }}</mat-label>
            <input matInput [matTimepicker]="endTimePicker" [formControl]="myControlEndTime">
            <mat-timepicker-toggle matIconSuffix [for]="endTimePicker"/>
            <button *ngIf="myControlEndTime.value" mat-button matSuffix mat-icon-button aria-label="Clear" (click)="resetEndTime()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-timepicker #endTimePicker/>
          </mat-form-field>

          <button mat-raised-button color="primary" (click)="compare()" [disabled]="!isDateRangeValid() || !selectedVehiclesData.data.length" >{{ 'TRIPS.VEHICLE.COMPARE' | translate }}</button>
    </div>
</div>
<div class="dual-table-container">
<!-- Left Table Section -->
<div class="table-section">
  <div *ngIf="!groupSelected" class="no-group-hint">
    {{ 'TRIPS.VEHICLE.SELECT_GROUP' | translate }}
  </div>
<table
*ngIf="groupSelected"
  mat-table
  matSort
  [dataSource]="availableVehiclesData"
  class="mat-elevation-z8"
  (matSortChange)="_originalVehiclesData.sortBy({ property: $event.active, order: $event.direction })"
  matSortActive="_name"
  matSortDirection="desc"
  matSortStart="desc"
>
  <ng-container matColumnDef="_name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'VEHICLE.NAME' | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      <span *ngIf="row.originalVehicleId && row.lastModified">
        {{ row.name }} {{ row.lastModified }}
      </span>
      <span *ngIf="!row.originalVehicleId">
        {{ row.name }}
      </span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr 
        mat-row 
        *matRowDef="let row; columns: displayedColumns"
        (click)="toggleVehicleSelection(row)"
        [class.selected]="vehicleSelection.isSelected(row)"
      ></tr>
<!-- No data template -->
<tr class="mat-row" *matNoDataRow>
  <td class="mat-cell hint-cell" [attr.colspan]="displayedColumns.length">
    <div *ngIf="groupSelected && availableVehiclesData.data.length == 0" class="no-data-message">
      {{ 'TRIPS.VEHICLE.HINT' | translate }}
    </div>
  </td>
</tr>
</table>

<mat-paginator 
    *ngIf="groupSelected && availableVehiclesData.data.length > 0"
    [length]="availableVehiclesData.data.length"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize"
    (page)="onAvailablePaginateChange($event)"
    #availablePaginator>
  </mat-paginator>
    </div>

<!-- Middle Controls Section -->    
<div class="controls-section">
  <ng-container *ngIf="selectedGroup">
  <button class="control-button move-all-right" mat-raised-button (click)="moveAllToSelected()">
    <mat-icon>keyboard_double_arrow_right</mat-icon>
  </button>
    <button class="control-button move-right" mat-raised-button (click)="moveToSelected()">
        <mat-icon>arrow_forward</mat-icon>
    </button>
    <button class="control-button move-left" mat-raised-button (click)="moveToAvailable()">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <button class="control-button move-all-left" mat-raised-button (click)="moveAllToAvailable()">
      <mat-icon>keyboard_double_arrow_left</mat-icon>
    </button>
  </ng-container>
  </div> 
<!-- Right Table Section -->
<div class="table-section">
  <div *ngIf="selectedVehiclesData.data.length == 0" class="no-group-hint">
    {{ 'TRIPS.VEHICLE.SELECTED' | translate }}
  </div>
    <table 
    *ngIf="selectedVehiclesData.data.length > 0"
    mat-table 
    matSort 
    [dataSource]="selectedVehiclesData"
    class="mat-elevation-z8"
    matSortActive="_name"
    matSortDirection="desc"
    matSortStart="desc"
  >
    <!-- Name Column -->
    <ng-container matColumnDef="_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'VEHICLE.NAME' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <span *ngIf="row.originalVehicleId && row.lastModified">
          {{ row.name }} {{ row.lastModified }}
        </span>
        <span *ngIf="!row.originalVehicleId">
          {{ row.name }}
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="selectedDisplayedColumns"></tr>
    <tr 
        mat-row 
        *matRowDef="let row; columns: selectedDisplayedColumns"
        (click)="toggleSelectedVehicleSelection(row)"
        [class.selected]="selectedVehicleSelection.isSelected(row)"
      ></tr>

  </table>
  <mat-paginator 
  *ngIf="selectedVehiclesData.data.length > 0"
  [length]="selectedVehiclesData.data.length"
  [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSize"
  (page)="onSelectedPaginateChange($event)"
  #selectedPaginator>
</mat-paginator>
</div>
</div>       
